import requestAction from '../../utils/requestAction';

export const fetchMassNotifications = (params: string = '') =>
  requestAction('MASS_NOTIFICATION_LIST', params)(`massNotifications`, 'GET');
